@if (loading) {
  <div class="page-loader">
    <mat-spinner class="spinner-reset"></mat-spinner>
  </div>
}

@if (!loading) {
  <div>
    <h2 class="section-title">
      {{ 'ADMIN.PROJECTS.EDIT_PROJECT.EDIT' | translate }}
      {{ project.name }}
    </h2>
    <div class="back-link">
      <mat-icon>keyboard_arrow_left</mat-icon>
      <a [routerLink]="['../../']">{{
        'ADMIN.PROJECTS.EDIT_PROJECT.BACK_TO_PROJECTS' | translate
      }}</a>
    </div>
    <form [formGroup]="form" (ngSubmit)="handleSubmit()">
      <mat-form-field>
        <mat-label>{{ 'ADMIN.PROJECTS.EDIT_PROJECT.PROJECT_NAME' | translate }}</mat-label>
        <input
          matInput
          type="text"
          placeholder="Ex.: VistaJet"
          [formControl]="form.controls.name"
          name="projectName"
        />
        @if (
          form.controls.name.invalid && (form.controls.name.dirty || form.controls.name.touched)
        ) {
          <mat-error>
            @if (form.controls.name.errors?.required) {
              {{ 'SHARED.VALIDATION.REQUIRED' | translate }}.
            }
          </mat-error>
        }
      </mat-form-field>
      <div>
        <mat-label class="label">{{
          'ADMIN.PROJECTS.EDIT_PROJECT.PERSONS_OF_INTEREST' | translate
        }}</mat-label>
        <div class="columns">
          <app-autocomplete-person
            [required]="true"
            [label]="'ADMIN.PROJECTS.EDIT_PROJECT.PARTNERSHIP_MANAGER' | translate"
            [options]="employees"
            [controller]="form.controls.manager"
          ></app-autocomplete-person>
          <app-autocomplete-person
            [required]="true"
            [label]="'ADMIN.PROJECTS.EDIT_PROJECT.PROJECT_EM' | translate"
            [options]="employees"
            [controller]="form.controls.engineeringManager"
          ></app-autocomplete-person>
          <app-autocomplete-person
            [label]="'ADMIN.PROJECTS.EDIT_PROJECT.PROJECT_LEAD' | translate"
            [options]="employees"
            [controller]="form.controls.lead"
          ></app-autocomplete-person>
        </div>
      </div>
      <div class="columns-second">
        <mat-form-field class="oracle-field">
          <mat-label>{{ 'ADMIN.PROJECTS.EDIT_PROJECT.ORACLE_EXTERNAL_ID' | translate }}</mat-label>
          <input
            matInput
            type="text"
            [formControl]="form.controls.oracleExternalId"
            name="oracleExternalId"
          />
        </mat-form-field>
        <div class="columns-second" formGroupName="billingProperties">
          <mat-form-field color="accent" appearance="fill">
            <mat-label>{{ 'ADMIN.PROJECTS.EDIT_PROJECT.BILLING_TYPE' | translate }}</mat-label>
            <mat-select formControlName="billingType">
              @for (billingType of billingTypes | keyvalue; track billingType) {
                <mat-option
                  [value]="billingType.value"
                  [disabled]="billingType.value === billingTypes.UNDEFINED"
                >
                  {{ 'ADMIN.PROJECTS.BILLING_PROPERTIES.' + billingType.value | translate }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>

          <mat-form-field color="accent" appearance="fill">
            <mat-label>{{ 'ADMIN.PROJECTS.EDIT_PROJECT.BILLING_RATE' | translate }}</mat-label>
            <mat-select formControlName="billingRate">
              @for (billingRate of billingRates | keyvalue; track billingRate) {
                <mat-option [value]="billingRate.value">
                  {{ 'ADMIN.PROJECTS.BILLING_PROPERTIES.' + billingRate.value | translate }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        <mat-checkbox
          class="time-logging-checkbox"
          [formControl]="form.controls.isTimelogRequired"
          name="isTimelogRequired"
          color="primary"
        >
          {{ 'ADMIN.PROJECTS.EDIT_PROJECT.IS_TIMELOG_REQUIRED' | translate }}
        </mat-checkbox>
      </div>
      @if (project.employees.length) {
        <div>
          <mat-label class="label">{{
            'ADMIN.PROJECTS.EDIT_PROJECT.EMPLOYEES' | translate
          }}</mat-label>
          <mat-chip-listbox aria-label="Fish selection">
            @for (employee of project.employees; track employee) {
              <a mat-chip class="clickable" [routerLink]="['/admin/employees', employee.id]">
                {{ employee.fullName }}
              </a>
            }
          </mat-chip-listbox>
        </div>
      }
      <div>
        <mat-label class="block">{{
          'ADMIN.PROJECTS.EDIT_PROJECT.DESCRIPTION' | translate
        }}</mat-label>
        <app-editor
          [formControl]="form.controls.description"
          name="projectDescription"
        ></app-editor>
      </div>
      <button
        type="submit"
        mat-raised-button
        color="primary"
        *appIfHasPermission="['viewAdmin.viewProjects.editProject', 'viewLead.viewLeadProjects']"
      >
        {{ 'SHARED.SUBMIT' | translate }}
      </button>
    </form>
  </div>
}
